var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"peoplex"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-163498ce","hasScoped":true,"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/peoplex.vue
// module id = 228
// module chunks = 1